module.exports = __webpack_public_path__ + "static/img/kb-card-app-contents-02-img-01@w.050f3bf.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/kb-card/kb-card-app-contents-02-img-01@w.png
// module id = TW9M
// module chunks = 0